import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import StringBuffer from '../../../../java/lang/StringBuffer';
import Location from '../geom/Location';
import Position from './Position';
import TopologyLocation from './TopologyLocation';
var Label = /*#__PURE__*/function () {
  function Label() {
    _classCallCheck(this, Label);
    Label.constructor_.apply(this, arguments);
  }
  _createClass(Label, [{
    key: "getGeometryCount",
    value: function getGeometryCount() {
      var count = 0;
      if (!this.elt[0].isNull()) count++;
      if (!this.elt[1].isNull()) count++;
      return count;
    }
  }, {
    key: "setAllLocations",
    value: function setAllLocations(geomIndex, location) {
      this.elt[geomIndex].setAllLocations(location);
    }
  }, {
    key: "isNull",
    value: function isNull(geomIndex) {
      return this.elt[geomIndex].isNull();
    }
  }, {
    key: "setAllLocationsIfNull",
    value: function setAllLocationsIfNull() {
      if (arguments.length === 1) {
        var location = arguments[0];
        this.setAllLocationsIfNull(0, location);
        this.setAllLocationsIfNull(1, location);
      } else if (arguments.length === 2) {
        var geomIndex = arguments[0],
          _location = arguments[1];
        this.elt[geomIndex].setAllLocationsIfNull(_location);
      }
    }
  }, {
    key: "isLine",
    value: function isLine(geomIndex) {
      return this.elt[geomIndex].isLine();
    }
  }, {
    key: "merge",
    value: function merge(lbl) {
      for (var i = 0; i < 2; i++) if (this.elt[i] === null && lbl.elt[i] !== null) this.elt[i] = new TopologyLocation(lbl.elt[i]);else this.elt[i].merge(lbl.elt[i]);
    }
  }, {
    key: "flip",
    value: function flip() {
      this.elt[0].flip();
      this.elt[1].flip();
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      if (arguments.length === 1) {
        var geomIndex = arguments[0];
        return this.elt[geomIndex].get(Position.ON);
      } else if (arguments.length === 2) {
        var _geomIndex = arguments[0],
          posIndex = arguments[1];
        return this.elt[_geomIndex].get(posIndex);
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      var buf = new StringBuffer();
      if (this.elt[0] !== null) {
        buf.append('A:');
        buf.append(this.elt[0].toString());
      }
      if (this.elt[1] !== null) {
        buf.append(' B:');
        buf.append(this.elt[1].toString());
      }
      return buf.toString();
    }
  }, {
    key: "isArea",
    value: function isArea() {
      if (arguments.length === 0) {
        return this.elt[0].isArea() || this.elt[1].isArea();
      } else if (arguments.length === 1) {
        var geomIndex = arguments[0];
        return this.elt[geomIndex].isArea();
      }
    }
  }, {
    key: "isAnyNull",
    value: function isAnyNull(geomIndex) {
      return this.elt[geomIndex].isAnyNull();
    }
  }, {
    key: "setLocation",
    value: function setLocation() {
      if (arguments.length === 2) {
        var geomIndex = arguments[0],
          location = arguments[1];
        this.elt[geomIndex].setLocation(Position.ON, location);
      } else if (arguments.length === 3) {
        var _geomIndex2 = arguments[0],
          posIndex = arguments[1],
          _location2 = arguments[2];
        this.elt[_geomIndex2].setLocation(posIndex, _location2);
      }
    }
  }, {
    key: "isEqualOnSide",
    value: function isEqualOnSide(lbl, side) {
      return this.elt[0].isEqualOnSide(lbl.elt[0], side) && this.elt[1].isEqualOnSide(lbl.elt[1], side);
    }
  }, {
    key: "allPositionsEqual",
    value: function allPositionsEqual(geomIndex, loc) {
      return this.elt[geomIndex].allPositionsEqual(loc);
    }
  }, {
    key: "toLine",
    value: function toLine(geomIndex) {
      if (this.elt[geomIndex].isArea()) this.elt[geomIndex] = new TopologyLocation(this.elt[geomIndex].location[0]);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this.elt = new Array(2).fill(null);
      if (arguments.length === 1) {
        if (Number.isInteger(arguments[0])) {
          var onLoc = arguments[0];
          this.elt[0] = new TopologyLocation(onLoc);
          this.elt[1] = new TopologyLocation(onLoc);
        } else if (arguments[0] instanceof Label) {
          var lbl = arguments[0];
          this.elt[0] = new TopologyLocation(lbl.elt[0]);
          this.elt[1] = new TopologyLocation(lbl.elt[1]);
        }
      } else if (arguments.length === 2) {
        var geomIndex = arguments[0],
          _onLoc = arguments[1];
        this.elt[0] = new TopologyLocation(Location.NONE);
        this.elt[1] = new TopologyLocation(Location.NONE);
        this.elt[geomIndex].setLocation(_onLoc);
      } else if (arguments.length === 3) {
        var _onLoc2 = arguments[0],
          leftLoc = arguments[1],
          rightLoc = arguments[2];
        this.elt[0] = new TopologyLocation(_onLoc2, leftLoc, rightLoc);
        this.elt[1] = new TopologyLocation(_onLoc2, leftLoc, rightLoc);
      } else if (arguments.length === 4) {
        var _geomIndex3 = arguments[0],
          _onLoc3 = arguments[1],
          _leftLoc = arguments[2],
          _rightLoc = arguments[3];
        this.elt[0] = new TopologyLocation(Location.NONE, Location.NONE, Location.NONE);
        this.elt[1] = new TopologyLocation(Location.NONE, Location.NONE, Location.NONE);
        this.elt[_geomIndex3].setLocations(_onLoc3, _leftLoc, _rightLoc);
      }
    }
  }, {
    key: "toLineLabel",
    value: function toLineLabel(label) {
      var lineLabel = new Label(Location.NONE);
      for (var i = 0; i < 2; i++) lineLabel.setLocation(i, label.getLocation(i));
      return lineLabel;
    }
  }]);
  return Label;
}();
export { Label as default };